import { Tag, Typography } from 'antd';
import type { Company } from '@viq-admin/types';
import { enabledFeatures } from './companyFeatures';

/**
 * A company's switched-on feature flags as short tags, so the company page
 * header and the companies list show what a tenant has without opening the
 * Feature flags tab.
 *
 * Plain antd only (no router, no scope provider) so the companies list can
 * use it without pulling anything else in.
 */
export function CompanyFeatureTags({
  company,
  emptyText,
}: {
  company: Partial<Company>;
  /** Shown when no flag is on; omit to render nothing. */
  emptyText?: string;
}) {
  const on = enabledFeatures(company);
  if (on.length === 0) {
    return emptyText ? <Typography.Text type="secondary">{emptyText}</Typography.Text> : null;
  }
  return (
    <span data-testid="company-feature-tags">
      {on.map((f) => (
        // CRM providers in blue so "which CRM" reads apart from the other switches.
        <Tag key={f.key} color={f.crm ? 'blue' : undefined} style={{ marginBlock: 2 }}>
          {f.label}
        </Tag>
      ))}
    </span>
  );
}
